import moment from 'moment';
import { constants } from 'dataforazeroth-common';
import utils from './utils';

function download(data, filename, type) {
    const element = document.createElement("a");
    const file = new Blob([ data ], { type });
    element.href = URL.createObjectURL(file);
    element.download = filename;
    document.body.appendChild(element);
    element.click();
}

function collection(collection, tpc) {
    const timestamp = moment.utc().format('YYYYMMDD.hhmmss');

    const showAppearances = tpc.showAppearances || tpc.showAppearancesources;
    const showSource = tpc.showMounts || tpc.showPets || tpc.showTitles || tpc.showRecipes || tpc.showToys || showAppearances || tpc.showHeirlooms || tpc.showSoulshapes || tpc.showManuscripts;
    const showApi = !tpc.showManuscripts && !tpc.showAppearancesources && !tpc.showDecor;

    const rows = collection.map(item => [
        // collected status
        item.id,
        item.name,
        item.character ? 'Collected' : (item.account ? 'Collected on Alt' : 'Not Collected'),

        // common info
        utils.obtainables.find(e => e.key === item.unobtainable)?.value || 'Obtainable',
        showApi ? (item.missing ? 'Missing from API' : 'Present in API') : undefined,
        showApi ? (item.excluded ? 'Excluded in Ranking' : 'Included in Ranking') : undefined,
        showApi ? (item.rarity || 0) : undefined,
        item.patch || '',

        showSource ? (item.sourceicon || 'other') : undefined,
        showSource ? (item.source || '') : undefined,
        showSource ? (item.sourcestanding ? item.sourcestanding : item.sourcezone || '') : undefined,

        showAppearances ? (item.slot || 'Other') : undefined,
        showAppearances ? (item.type || 'Other') : undefined,

        tpc.showAchievements ? (item.points || 0) : undefined,
        tpc.showAchievements ? (item.category || '') : undefined,
        tpc.showAchievements ? (item.subcategory || '') : undefined,

        tpc.showRecipes ? (item.prof || '') : undefined,

        tpc.showQuests ? (item.category || '') : undefined
    ]);

    rows.unshift([
        'ID',
        tpc.show + ' for ' + tpc?.character1?.key + ' @ ' + timestamp,
        'Collected',

        'Unobtainable',
        showApi ? 'Missing' : undefined,
        showApi ? 'Excluded' : undefined,
        showApi ? 'Rarity' : undefined,
        'Patch',

        showSource ? 'Source Type' : undefined,
        showSource ? 'Source' : undefined,
        showSource ? 'Source Extra' : undefined,

        showAppearances ? 'Slot' : undefined,
        showAppearances ? 'Type' : undefined,

        tpc.showAchievements ? 'Points' : undefined,
        tpc.showAchievements ? 'Category' : undefined,
        tpc.showAchievements ? 'Sub-Category' : undefined,

        tpc.showRecipes ? 'Profession' : undefined,

        tpc.showQuests ? 'Category' : undefined
    ]);

    const csv = rows.map(row => row.filter(e => e !== undefined).map(e => utils.escapeCsv(e)).join(',')).join('\n');
    download(csv, tpc.show + '.' + timestamp + '.csv', 'text/csv');
}

function characters(array) {
    const timestamp = moment.utc().format('YYYYMMDD.hhmmss');

    const FACTIONSMAP = {};
    utils.factions.forEach(f => FACTIONSMAP[f.key] = f.value);

    const RACESMAP = {};
    constants.races.forEach(r => RACESMAP[r.key] = r.value);

    const CLASSESMAP = {};
    utils.classes.forEach(c => CLASSESMAP[c.key] = c.value);

    const PROFESSIONS = {};
    utils.professions.forEach(p => PROFESSIONS[p.toLowerCase()] = p);
    [ 'archaeology', 'cooking', 'fishing', 'gnomish engineering', 'goblin engineering' ].forEach(p => delete PROFESSIONS[p]);

    const profs = (c) => {
        const jcp = Object.keys(c?.character?.professions || {}).map(key => PROFESSIONS[key]).filter(p => p);
        jcp.sort((a, b) => utils.collator.compare(a, b));
        return jcp;
    };

    const accountName = (id) => {
        const rename = localStorage.getItem('rename.' + id);
        return rename || ('Account #' + (id || 'Unknown'));
    };

    const rows = array.map(c => [
        c?.character?.name || '',
        c?.character?.realm || '',
        FACTIONSMAP[c?.character?.faction] || '',
        RACESMAP[c?.character?.race] || '',
        CLASSESMAP[c?.character?.class] || '',
        profs(c)[0] || '',
        profs(c)[1] || '',
        c?.character?.level || '',
        c?.character?.averageItemLevel || '',
        c?.character?.guildName || '',
        accountName(c?.wowaccount) || ''
    ]);

    rows.unshift([
        'Name',
        'Realm',
        'Faction',
        'Race',
        'Class',
        'Profession 1',
        'Profession 2',
        'Level',
        'Item Level',
        'Guild',
        'Account'
    ]);

    const csv = rows.map(row => row.filter(e => e !== undefined).map(e => utils.escapeCsv(e)).join(',')).join('\n');
    download(csv, 'mycharacters.' + timestamp + '.csv', 'text/csv');
}

const ex = { download, collection, characters };
export default ex;